import { isEqual } from "lodash";
import { useEffect, useRef } from "react";

type TAnyObjectArray = Object | Array<any> | any;

// tracks and returns previous value
// named usePreviousWF (WF for Wild Fork) to avoid collisions with third party libraries using a common name
export const usePreviousWF = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

/*  useMemoizeStruct
 **
 **  memoizes any struct (object or array reference)
 **
 **  it accepts an optional equality comparator function as the 2nd argument but it defaults to isEqual (lodash deep comparison)
 **
 */
export const useMemoizeStruct = <K extends TAnyObjectArray>(
  struct: K,
  equalityFunc: (val1: any, val2: any, options?: any) => boolean = isEqual
): K => {
  const prevStruct = usePreviousWF(struct);
  const structHasNotChanged =
    prevStruct !== undefined && equalityFunc(struct, prevStruct);
  const structRef = useRef(struct);
  useEffect(() => {
    if (!structHasNotChanged) {
      (structRef as any).current = struct;
    }
  });
  return structHasNotChanged ? structRef.current : struct;
};
